import { useContext, useEffect, useEffectEvent, useState } from 'react'
import { useAuth } from 'react-oidc-context'

import { AppContext, useHost } from '../../providers/app-provider'
import Api from '../api'

const useFolderTheme = (folderId: number | undefined) => {
  const { pageRefreshCounter } = useContext(AppContext)
  const auth = useAuth()
  const host = useHost()
  const [theme, setTheme] = useState<IFolderTheme | undefined>()

  const fetchTheme = useEffectEvent(async () => {
    if (!host || !auth.user?.access_token) return
    setTheme(undefined)
    if (folderId) {
      // Fetch the theme for the folder
      const response = await Api.get(`${host}/api/folders/${folderId}/theme`)
      if (response.ok) {
        setTheme(response.body.theme)
      }
    }
  })
  useEffect(() => {
    fetchTheme()
  }, [folderId, host, pageRefreshCounter])

  return { folderTheme: theme }
}

export default useFolderTheme
